/**
 * Shared Capsule Pagination for Eurus Theme Splide Sliders
 * Active capsule: 34x6px (#f07e48)
 * Inactive capsule: 22x6px (#0000002e)
 * Gap: 8px
 */
(function () {
  'use strict';

  function initCapsuleForElement(root) {
    if (!root) return;

    const container = root.querySelector('.capsule-pagination') || 
                      (root.parentElement ? root.parentElement.querySelector('.capsule-pagination') : null);
    if (!container) return;

    const splide = root.splide;
    if (!splide) return;

    function getPerPage() {
      const width = window.innerWidth;
      const opts = splide.options || {};
      if (opts.breakpoints) {
        if (width >= 1024 && opts.breakpoints[1024] && opts.breakpoints[1024].perPage) {
          return opts.breakpoints[1024].perPage;
        }
        if (width >= 768 && opts.breakpoints[768] && opts.breakpoints[768].perPage) {
          return opts.breakpoints[768].perPage;
        }
        if (width < 768 && opts.breakpoints[300] && opts.breakpoints[300].perPage) {
          return opts.breakpoints[300].perPage;
        }
      }
      return opts.perPage || 1;
    }

    function renderDots() {
      container.innerHTML = '';
      const slides = splide.Components.Slides ? splide.Components.Slides.get() : [];
      const totalSlides = slides.length;
      const perPage = getPerPage();
      const totalPages = Math.ceil(totalSlides / perPage);

      if (totalPages <= 1) {
        container.style.display = 'none';
        return;
      }
      container.style.display = 'flex';

      const currentPage = Math.floor((splide.index || 0) / perPage);

      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'capsule-dot' + (i === currentPage ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
        
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const targetSlide = Math.min(i * perPage, totalSlides - 1);
          splide.go(targetSlide);
          updateActive(targetSlide);
        });
        
        container.appendChild(dot);
      }
    }

    function getPageForIndex(idx) {
      if (splide.Components && splide.Components.Controller && typeof splide.Components.Controller.toPage === 'function') {
        return splide.Components.Controller.toPage(idx);
      }
      const perPage = getPerPage();
      return Math.floor(idx / perPage);
    }

    function updateActive(targetIndex) {
      let idxToUse = (typeof targetIndex === 'number') ? targetIndex : splide.index;
      if (typeof idxToUse !== 'number' || isNaN(idxToUse)) {
        idxToUse = splide.index || 0;
      }
      const currentPage = getPageForIndex(idxToUse);
      const dots = container.querySelectorAll('.capsule-dot');
      dots.forEach((dot, idx) => {
        if (idx === currentPage) {
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }
      });
    }

    splide.on('move moved active', (newIndex) => {
      if (typeof newIndex === 'number') {
        updateActive(newIndex);
      } else {
        updateActive(splide.index);
      }
    });
    splide.on('resized refresh', () => {
      renderDots();
      updateActive();
    });
    window.addEventListener('resize', () => {
      renderDots();
      updateActive();
    });

    renderDots();
  }

  function initSectionSliders(sectionId) {
    const ids = [
      'x-product-recommendation-' + sectionId,
      'recently-viewed-tab--' + sectionId,
      'x-recently-viewed-' + sectionId,
      'shopify-section-recently-viewed'
    ];

    ids.forEach((id) => {
      const root = document.getElementById(id);
      if (!root) return;

      const splideRoots = root.classList.contains('splide') ? [root] : Array.from(root.querySelectorAll('.x-splide.splide'));
      splideRoots.forEach((splideEl) => {
        if (splideEl.splide) {
          initCapsuleForElement(splideEl);
        } else {
          let attempts = 0;
          const timer = setInterval(() => {
            attempts++;
            if (splideEl.splide) {
              clearInterval(timer);
              initCapsuleForElement(splideEl);
            } else if (attempts > 40) {
              clearInterval(timer);
            }
          }, 50);
        }
      });
    });
  }

  // Intercept Eurus splide-ready custom events globally
  const origDispatch = document.dispatchEvent;
  document.dispatchEvent = function (event) {
    origDispatch.apply(this, arguments);
    if (event && event.type && event.type.includes(':splide-ready')) {
      const parts = event.type.split(':');
      if (parts.length >= 2) {
        const sectionId = parts[1];
        setTimeout(() => initSectionSliders(sectionId), 20);
      }
    }
  };

  // Also expose global function just in case
  window.initCapsulePagination = function (elementId) {
    const root = document.getElementById(elementId);
    if (root) initCapsuleForElement(root);
  };
})();
